// Add your custom JS here.


/**
 * Add / remove classes on scroll
 *
 * - Add 'scrolled' class to body
 * - Add 'bg-white' class to sticky navbar
 */

var bodyEl = document.querySelector('body');
var navEl = document.querySelector('#wrapper-navbar-sticky');

window.onscroll = function() {
  windowScroll();
}

function windowScroll() {
  bodyEl.classList.toggle('scrolled', bodyEl.scrollTop > 50 || document.documentElement.scrollTop > 50);
  navEl.classList.toggle('bg-white', navEl.scrollTop > 50 || document.documentElement.scrollTop > 50);
}



/**
 * Edit cf7 form structure for bootstrap floating labels
 *
 * Edits cfs form fields when written as: [form tag]<label>Label</label>
 */

window.addEventListener('DOMContentLoaded', function understrapWpcf7FloatingLabels() {

  const items = document.querySelectorAll('.wpcf7-form-control-wrap');

  for (let item of items) {
    // if <label> inserted after [form tag]
    if (item.nextSibling.tagName === 'LABEL') {
      let input = item.querySelector('.wpcf7-form-control');
      let fieldName = input.getAttribute('name');
      let att = 'floating' + fieldName;
      let label = item.nextSibling;

      // add classes to .wpcf7-form-control-wrap
      item.classList.add('form-floating','d-block');

      // append label to input and add attribute
      item.appendChild(label);
      label.setAttribute('for', att);

      // add attributes to <input>
      input.setAttribute('id', att);
      input.setAttribute('placeholder', '');
      input.classList.add('form-control');
    }
  }
}, false);



/**
 * Initialise masonry-layout
 */
/*var elem = document.querySelector('.masonry-card-group');
var msnry = new Masonry( elem, {
  // options
  itemSelector: '.card',
  columnWidth: '.card',
  percentPosition: true,
  gutter: 16
});*/



(function( $ ) {
  // init masonry-layout
	var $grid = $('.masonry-card-group').masonry({
  	// options
	  itemSelector: '.card',
  	columnWidth: '.card-masonry-sizer',
		percentPosition: true,
		gutter: 16,
	});

  // @TODO needs work / needs testing
  $(document).on('wpsolr_on_ajax_success', function(){
    console.log('wpsolr_on_ajax_success');
    var $grid = $('.masonry-card-group').masonry({
      // options
      itemSelector: '.card',
      columnWidth: '.card-masonry-sizer',
      percentPosition: true,
      gutter: 16
    });
    $grid.masonry('reloadItems')
    $grid.masonry('layout');
  });

})(jQuery);


